import React, { Component } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import ScrollLock from'react-scrolllock';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import './Menu.css';
import mailIcon from '../../icons/ic_mail_menu.svg';
import twitterIcon from '../../icons/ic_twitter_menu.svg';
import githubIcon from '../../icons/ic_github_menu.svg';
import { MENU_HEIGHT } from '../../index';
import { trackInnerTextClick, trackHostClick } from '../../utils';

class Menu extends Component {

  constructor(props) {
    super(props);

    this.state = {
      toggle: false,
    };

    this.handleSelection = this.handleSelection.bind(this);
  }

  toggle() {
    this.setState({
      toggle: !this.state.toggle
    });
  }

  handleSelection(e) {
    this.setState({
      toggle: !this.state.toggle,
    });
    trackInnerTextClick(e, 'a mobile menu intem');
  }

  render() {

    let scrollLocker = null;
    let overlay = null;

    if (this.state.toggle) {
      scrollLocker = (
        <ScrollLock />
      );
      overlay = (
        <div className="lp-mobile-menu-overlay">
          <div className="lp-items">
            <AnchorLink offset={MENU_HEIGHT} href="#lp-josm" onClick={this.handleSelection}>
              <div>JOSM</div>
            </AnchorLink>
            <AnchorLink offset={MENU_HEIGHT} href="#lp-tools" onClick={this.handleSelection}>
              <div>TOOLS</div>
            </AnchorLink>
            <AnchorLink offset={MENU_HEIGHT} href="#lp-data-dumps" onClick={this.handleSelection}>
              <div>DATA DUMPS</div>
            </AnchorLink>
            {/* <AnchorLink offset={MENU_HEIGHT} href="#lp-ai" onClick={this.handleSelection}>
              <div>AI</div>
            </AnchorLink> */}

            <div className="lp-social-media">
              <div>
                <a href="https://www.gmail.com" target="_blank" rel="noopener noreferrer" onClick={e => trackHostClick(e, 'a social media button from the mobile menu')}>
                  <img src={mailIcon} alt="Email Us Icon"/>
                </a>
                <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" onClick={e => trackHostClick(e, 'a social media button from the mobile menu')}>
                  <img src={twitterIcon} alt="Twitter Icon"/>
                </a>
                <a href="https://www.github.com" target="_blank" rel="noopener noreferrer" onClick={e => trackHostClick(e, 'a social media button from the mobile menu')}>
                  <img src={githubIcon} alt="Github Icon"/>
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div
        className="lp-mobile-menu-container"
        style={{
          height: this.props.height,
        }}
      >
        {scrollLocker}
        <div className="lp-mobile-menu-core">

          <a className="lp-logo" href="#home">
            <div>
              ImproveOSM<span>.org</span>
            </div>
          </a>

          <div onClick={this.toggle.bind(this)} className={'lp-menu-toggle' + (this.state.toggle ? ' transform-cross' : ' transform-lines')}>
            <div className="outer-line top-effect">
              <div className="inner-line"></div>
            </div>
            <div className="outer-line middle-effect">
              <div className="inner-line"></div>
            </div>
            <div className="outer-line bottom-effect">
              <div className="inner-line"></div>
            </div>
          </div>

        </div>

        <ReactCSSTransitionGroup
          transitionName="lp-overlay"
          transitionAppear={true}
          transitionAppearTimeout={500}
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
          transitionEnter={true}
          transitionLeave={true}
        >
          {overlay}
        </ReactCSSTransitionGroup>

      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/mobile/Menu.js